/*
 * Prompt debug mode, client side (097).
 *
 * A single admin-only switch. When it is on, every API request carries X-Birdsy-Debug: 1, and the
 * server -- after checking the caller really is an admin -- keeps the exact object it handed to the
 * OpenAI SDK so it can be read back next to the reply it produced.
 *
 * The flag lives in localStorage rather than React state because do-fetch.js is not a component and
 * has to read it on every request. The context in PromptDebugContext mirrors it so the UI
 * re-renders when it changes; this module is the source of truth both consult.
 */

const STORAGE_KEY = 'birdsy.debugPrompts'
const EVENT = 'birdsy:debug-prompts-changed'

const isPromptDebugEnabled = () => {
	try {
		return window.localStorage.getItem(STORAGE_KEY) === '1'
	}
	catch (err) {
		// private mode, or storage disabled -- debug mode simply stays off
		return false
	}
}

const setPromptDebugEnabled = (enabled) => {
	try {
		if (enabled) window.localStorage.setItem(STORAGE_KEY, '1')
		else window.localStorage.removeItem(STORAGE_KEY)
	}
	catch (err) {
		// nothing to do: the toggle just will not persist
	}
	// same-tab listeners; the native `storage` event only fires in OTHER tabs
	window.dispatchEvent(new Event(EVENT))
}

const onPromptDebugChanged = (handler) => {
	window.addEventListener(EVENT, handler)
	return () => window.removeEventListener(EVENT, handler)
}

export {STORAGE_KEY, isPromptDebugEnabled, setPromptDebugEnabled, onPromptDebugChanged}
